import { PageContainer } from '@/components/page/PageContainer';
import { PageSizer, SizerMode } from '@/components/page/PageSizer';
import { TSTitleCard } from '@/components/shared/card/Card';
import { useGetMeQuery } from '@/services/gql/graphql.generated';
import { FC } from 'react';
import { FiUser } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import strings from '../ess.translations';
import { MyProfileHeader } from './MyProfileHeader';

export const MyProfile: FC = () => {
  const navigate = useNavigate();

  const [{ data }] = useGetMeQuery();
  const profileData = data?.myEmployee;
  if (!profileData) {
    throw Error('No profile data available');
  }

  const onEditClick = () => {
    navigate(`edit`);
  };

  return (
    <PageContainer customHeader={<MyProfileHeader />}>
      <PageSizer mode={SizerMode.PAGE}>
        <TSTitleCard
          title={strings.personalInformation}
          icon={FiUser}
          primaryAction={{
            label: strings.myProfile.editLabel,
            onClick: onEditClick
          }}
        >
          <div className="flex flex-col gap-4 pt-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <div className="font-semibold">{strings.common.firstName}</div>
                <div>{profileData.firstName ?? '-'}</div>
              </div>
              <div>
                <div className="font-semibold">{strings.common.lastName}</div>
                <div>{profileData.lastName ?? '-'}</div>
              </div>
            </div>
            <div className="grid break-all grid-cols-1 gap-4">
              {profileData.employeeId && (
                <div>
                  <div className="font-semibold">{strings.common.organizationId}</div>
                  <div>{profileData.employeeId}</div>
                </div>
              )}
              {profileData.email && (
                <div>
                  <div className="font-semibold">{strings.common.email}</div>
                  <div className="text-blue-400 hover:text-purple-600">
                    <a href={'mailto:' + profileData.email}>{profileData.email}</a>
                  </div>
                </div>
              )}
              {profileData.phoneNumber && (
                <div>
                  <div className="font-semibold">{strings.common.phoneNumber}</div>
                  <div className="text-blue-400 hover:text-purple-600">
                    <a href={'tel:' + profileData.phoneNumber}>{profileData.phoneNumber}</a>
                  </div>
                </div>
              )}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <div className="font-semibold">{strings.role}</div>
                <div>{profileData.role}</div>
              </div>
            </div>
          </div>
        </TSTitleCard>
      </PageSizer>
    </PageContainer>
  );
};
